// extracted by mini-css-extract-plugin
export var FaqAccordion = "Faq-module--FaqAccordion--42kET";
export var FaqSectionWrapper = "Faq-module--FaqSectionWrapper---HTrr";